export default __webpack_public_path__ + "static/media/sheba.b766cc33.jpeg";